import { Component } from '@angular/core';

@Component( {
    selector: 'app-security-check',
    templateUrl: './security-check.component.html',
    standalone: true
} )
export class SecurityCheckComponent {
}
